import styled from 'styled-components'

export const StepperModalContainer = styled.div`
  padding: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  @media (max-width: 768px) {
    overflow-y: scroll;
  }
`

export const StepperModalActionsButtonContainer = styled.div<{paddingTop?: string}>`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: ${({paddingTop}) => paddingTop};

  @media (max-width: 1200px) {
    padding-top: 0px;
  }

  @media (max-width: 1024px) {
    justify-content: center;
  }
`

export const StepperModalBarrierContainer = styled.div`
  display: flex;
  gap: 16px;
  min-height: 500px;

  .separation {
    display: block;
  }
  @media (max-width: 1024px) {
    .separation {
      display: none;
      max-height: 290px;
    }
  }

  @media (max-height: 990px) {
    min-height: 300px;
  }

  @media (max-height: 750px) {
    min-height: 0px;
  }
`
